import { injectGlobal } from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import { baseFont } from './sharedStyle/font';

const applyGlobalStyles = () => {
  injectGlobal`
    /* https://w3g.jp/blog/use_yufamily */
    @font-face {
      font-family: 'MyYuGothicM';
      font-weight: normal;
      src: local('YuGothic-Medium'),
      local('Yu Gothic Medium'),
      local('YuGothic-Regular');
    }
    @font-face {
      font-family: 'MyYuGothicM';
      font-weight: bold;
      src: local('YuGothic-Bold'),
      local('Yu Gothic');
    }

    html {
      box-sizing: border-box;
      font-size: 81.25%;
    }

    *,
    *:before, *:after {
      box-sizing: inherit;
    }

    body {
      margin: 0;
      padding: 0;
      font-size: 1rem;
      color: ${colors.slate__4c566c};
      background-color: #fff;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      -webkit-text-size-adjust: 100%;
    }

    body,
    input,
    select,
    textarea,
    button {
      font-family: ${baseFont};
    }

    a {
      color: ${colors.denim__5fa9ff};
      text-decoration: none;

      :hover {
        color: ${colors.denim__5fa9ff};
        text-decoration: underline;
        background-color: transparent;
      }
    }

    /* headroom.js */
    .animated {
      -webkit-animation-duration: 200ms;
      animation-duration: 200ms;
    }
    .headroom--top.slideDown {
      top: 110px;
      position: fixed;
    }
    @-webkit-keyframes slideDown {
      0% {
        -webkit-transform: translateY(-200%);
      }

      100% {
        -webkit-transform: translateY(-100%);
      }
    }
    @-moz-keyframes slideDown {
      0% {
        -moz-transform: translateY(-200%);
      }

      100% {
        -moz-transform: translateY(-100%);
      }
    }
    @-o-keyframes slideDown {
      0% {
        -o-transform: translateY(-200%);
      }

      100% {
        -o-transform: translateY(-100%);
      }
    }
    @keyframes slideDown {
      0% {
        transform: translateY(-200%);
      }

      100% {
        transform: translateY(-100%);
      }
    }
    .animated.slideDown {
      -webkit-animation-name: slideDown;
      -moz-animation-name: slideDown;
      -o-animation-name: slideDown;
      animation-name: slideDown;
    }
    @-webkit-keyframes slideUp {
      0% {
        -webkit-transform: translateY(-100%);
      }

      100% {
        -webkit-transform: translateY(-200%);
      }
    }
    @-moz-keyframes slideUp {
      0% {
        -moz-transform: translateY(-100%);
      }

      100% {
        -moz-transform: translateY(-200%);
      }
    }
    @-o-keyframes slideUp {
      0% {
        -o-transform: translateY(-100%);
      }

      100% {
        -o-transform: translateY(-200%);
      }
    }
    @keyframes slideUp {
      0% {
        transform: translateY(-100%);
      }

      100% {
        transform: translateY(-200%);
      }
    }
    .animated.slideUp {
      -webkit-animation-name: slideUp;
      -moz-animation-name: slideUp;
      -o-animation-name: slideUp;
      animation-name: slideUp;
    }
  `;
};

export default applyGlobalStyles;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/applyGlobalStyles.ts